module.exports = __webpack_public_path__ + "static/media/reports-icon-white.5063a5d5.svg";